<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage stocks</small>
      </legend>
      <button
       
        class="btn btn-success btn-roundec"
       @click="loadStock()"
      >
        <i class="fa fa-file-pdf-o"></i> STOCK STATUS
      </button>
      <p></p>
      <div></div>
      <div>
        <div class="stocksLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color:blue"></i>loading stocks...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemStocks"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        ></vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment, { now } from "moment";
export default {
  data() {
    return {
      columns: [
        {
          label: "Product number",
          field: "product_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod number"
          }
        },
        {
          label: "Product name",
          field: "product_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod name"
          }
        },
        {
          label: "Product description",
          field: "product_description",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod description"
          }
        },
        {
          label: "measurement",
          field: "product_measurement",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter prod measurement"
          }
        },
        {
          label: "Stock qty",
          field: "balance_stock",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter in stock"
          }
        }
      ]
    };
  },

  created() {
    this.loadStocks();
  },
  computed: {
    ...mapGetters(["systemStocks"])
  }, 
  methods: {
      ...mapActions(["loadStocks", "loadStock"])
  }
};
</script>


// WEBPACK FOOTER //
// src/stocks/managestocks.vue